/**
 * Make the Swiper Slider show the arrows as they did before when it was flickity
 *
 * @param {Object} sliderSettings The settings for the slider activated
 */
wp.hooks.addFilter( 'qala_theme.filter.slider_settings', 'linliving', swiperAddSettings, 10 );

function swiperAddSettings( settings, targetSwiperEl ) {
	const swiperCount = document.querySelectorAll( '.product-images-slider-item-thumb' ).length;
	if ( swiperCount < 7 ) {
		return settings;
	}

	if ( ! targetSwiperEl.classList.contains( 'product-images-slider-thumbnails' ) ) {
		return settings;
	}

	const navSettings = {
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	};

	targetSwiperEl.innerHTML += '<div class="swiper-navigation"><div class="swiper-button-prev"></div><div class="swiper-button-next"></div></div>';

	settings = { ...settings, ...navSettings };

	return settings;
}
